module.exports = __webpack_public_path__ + "static/media/31.e23695b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/31.jpg
// module id = 564
// module chunks = 0